module.exports = __webpack_public_path__ + "static/media/mianshifankui1.c09d8398.png";